import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { APPOINTMENT_PUBLIC_REQUEST_FORM_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const PublicRequestFormPage = lazy(() => import('./pages/PublicRequestFormPage/PublicRequestFormPage'));

export const PUBLIC_APPOINTMENT_ROUTES: RouteConfig[] = [
  {
    availableViews: [LayoutType.COMMON],
    component: () => <PublicRequestFormPage />,
    displayTitle: () => 'Appointment Request Form',
    layoutProps: {
      isHideFooter: true,
    },
    pageType: PageType.PUBLIC,
    path: APPOINTMENT_PUBLIC_REQUEST_FORM_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.appointments,
  },
];
